import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import SecurityHome from './SecurityHome';
import SecurityVisitors from './SecurityVisitors';
import SecurityAmenities from './SecurityAmenities';
import SecurityAnnouncements from './SecurityAnnouncements';
import Events from '@/pages/Events';

const SecurityDashboard = () => {
  return (
    <DashboardLayout role="security">
      <Routes>
        <Route index element={<SecurityHome />} />
        <Route path="visitors" element={<SecurityVisitors />} />
        <Route path="amenities" element={<SecurityAmenities />} />
        <Route path="announcements" element={<SecurityAnnouncements />} />
        <Route path="events" element={<Events />} />
      </Routes>
    </DashboardLayout>
  );
};

export default SecurityDashboard;